<div class="content-wrapper" id="bannerClose">
    <div class="page-header">
        <h4 class="page-titles">
            <span class="page-title-icons bg-gradient-primary text-white mr-2">
                <i class="mdi mdi-file-document"></i>
            </span> รายงานงบการเงิน
        </h4>
    </div>

    <div class="d-flex align-items-center justify-content-between" style="cursor: context-menu;">
        <h4 class="mb-3">รายงานสถานะทางการเงิน ณ วันที่ {{financial_status.date}}</h4>
    </div>
    <div class="row" style="cursor: pointer;" >
        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 grid-margin stretch-card" style="margin-bottom: 0px;">
            <div class="row">
                <div class="row col-12">
                    <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                        <div class="card bg-gradient-danger card-img-holder text-white">
                            <div class="card-body px-4 py-4">
                                <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                    alt="circle-image">
                                <h4 class="mb-3">บัญชีเงินฝากประจำ</h4>
                                <h3 class="mb-2">{{financial_status.acc_fixed | number:'1.2-2'}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                        <div class="card bg-gradient-primary card-img-holder text-white">
                            <div class="card-body px-4 py-4">
                                <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                    alt="circle-image">
                                <h4 class="mb-3">บัญชีเงินฝากออมทรัพย์</h4>
                                <h3 class="mb-2">{{financial_status.acc_savings | number:'1.2-2'}}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row col-12">
                    <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                        <div class="card bg-gradient-info card-img-holder text-white">
                            <div class="card-body px-4 py-4">
                                <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                    alt="circle-image">
                                <h4 class="mb-3">บัญชีเงินฝากกระแสรายวัน</h4>
                                <h3 class="mb-2">{{financial_status.acc_current | number:'1.2-2'}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                        <div class="card bg-gradient-warning card-img-holder text-white">
                            <div class="card-body px-4 py-4">
                                <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                    alt="circle-image">
                                <h4 class="mb-3">เงินฝากกระทรวงการคลัง</h4>
                                <h3 class="mb-2">{{financial_status.acc_deposits | number:'1.2-2'}}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 grid-margin stretch-card" style="margin-bottom: 0px;">
            <div class="card bg-gradient-success card-img-holder text-white grid-margin stretch-card">
                <img src="assets/images/dashboard/circle.svg" class="card-img-absolute" alt="circle-image">
                <div class="v-center">
                    <h3 class="mb-4">รวมเงินฝากทั้งสิ้น</h3>
                    <h2 class="mb-2">{{financial_status.acc_sum | number:'1.2-2'}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 col-sm-12 grid-margin">
    <div class="card">
        <div class="card-body">
            <h4 class="card-title" style="cursor:pointer;">สรุปผลการดำเนินงาน</h4>
            <div>
                <div echarts [options]="options" class="demo-chart"></div>
            </div>
        </div>
    </div>
    </div>
    </div>

    <div class="row">
        <div class="col-md-12 col-sm-12 grid-margin">
            <div class="card"*ngIf="displayList">
                <div class="card-body">
                    <div class="row">
                        <div class="text-left col-lg-6 col-sm-12">
                            <h4>รายงานผู้สอบบัญชี</h4>
                        </div>
                        <div class="textt-right col-lg-6 col-sm-12" >
                            <select class="form-control form-control-lg" id="exampleFormControlSelect1"
                                style="width: 150px; height: 40px; float: right;" (change)="selectYear()" name="year_select"
                                [(ngModel)]="year_select">
                                <option [disabled]="true" value="">ค้นหาปีงบประมาณ</option>
                                <option *ngFor="let year of years" value="{{year}}">{{year}}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <colgroup>
                                <col style="width: 2%; text-align: center;">
                                <col style="width: 15%;">
                                <col style="width: 43%;">
                                <col style="width: 20%;">
                                <col style="width: 20%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="text-center"> </th>
                                    <th class="text-center"> ปีงบประมาณ </th>
                                    <th class="text-center"> ชื่อไฟล์ </th>
                                    <th class="text-center"> วันที่อัพโหลด</th>
                                    <th class="text-center"> </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of data_select| paginate : {
                                    itemsPerPage: tableSize,
                                    currentPage: page,
                                    totalItems: count
                                  };" style="cursor: pointer;">
                                    <td class="text-center"><i class="mdi mdi-file-document"></i></td>
                                    <td class="text-center">{{data.year}}</td>
                                    <td style="white-space: nowrap; 
                                    max-width: 30vw;
                                    overflow: hidden;
                                    text-overflow: ellipsis;" title="{{data.pdf_name}}">{{data.pdf_name}}</td>
                                    <td class="text-center">{{data.date_report}}</td>
                                    <td class="text-center">
                                        <!-- <button type="button"
                                            class="btn btn-inverse-danger btn-icon btn-sm"
                                            (click)="onClickView(data.pdf_file, data.pdf_name)">
                                            <i class="mdi mdi-eye"></i>
                                        </button>
                                        <button type="button" class="btn btn-inverse-primary btn-icon btn-sm"
                                            style="margin-left: 10px;"
                                            (click)="onClickDownload(data.pdf_file, data.pdf_name)">
                                            <i class="mdi mdi-download"></i>
                                        </button> -->
                                        <a href="https://ogc.mapedia.co.th/api/v1/lrfund/m_file/{{ data.pdf_file }}" type="button" class="btn btn-inverse-primary btn-sm" target="_blank" ><i class="mdi mdi-file-document" style="font-size: 12px;"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <pagination-controls previousLabel="ก่อนหน้า" nextLabel="ถัดไป" class="my-pagination"
                    (pageChange)="onTableDataChange($event)" style="text-align: center;">
                </pagination-controls>
            </div>
            <div class="card" style="border-radius: 15px;" *ngIf="displayPdf">
                <div class="card-body">
                    <div class="row">
                        <div class="col-6 text-left" style="cursor:context-menu;">{{pdfName}}</div>
                        <div class="col-6 text-right"><button type="button" class="btn btn-outline-success"
                                (click)="onClickClose()">ย้อนกลับ</button></div>
                    </div>
                    <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
                </div>
            </div>
        </div>
    </div>
</div>